//imports
import { useEffect, useState } from "react";
import {
    Box,
    AppBar,
    Grid,
    Stack, CircularProgress,
    Breadcrumbs,
    Link,Snackbar, Alert,
    Chip, TextField, Autocomplete, Button, Dialog, DialogTitle, DialogContent, DialogActions,
} from "@mui/material";
import FactCheckIcon from '@mui/icons-material/FactCheck';
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { externalgetApi } from "../../services/external/externalApis";
import { ORDER_API_03, Approveorder_API_01 } from "../../api/ApiModel";
import {
    CON_STATUS_ACTIVE,
    CON_STATUS_DELETED,
    CON_STATUS_PENDING,
    CON_STATUS_RETURN, CON_STATUS_NO, CON_IS_CASHIER_YES,
    CON_STATUS_RECEIVED,
} from "../../utils/sys/Constants";
import currencyFormat from "../../../src/utils/common/CurrencyFormat";
import {
    externalpostApi,

} from "../../services/external/externalApis";
import { useSelector } from "react-redux";
import Navbar from "../../components/common/Navbar";
import ViewData from "../../components/grids/ViewDatagrid";
import { Pendindapprovalslistdata } from "../../assets/Griddata";
import { useStyles } from "../../assets/styles/Theme";

import PhonelinkEraseIcon from "@mui/icons-material/PhonelinkErase";
import dayjs from "dayjs";

//hooks
const currentDate = new Date();
const currentYear = currentDate.getFullYear();
const currentMonth = String(currentDate.getMonth() + 1).padStart(2, "0");

const startOfMonth = dayjs().startOf("month");

const endOfMonthDate = dayjs().endOf("month");
function Pendingapprovals() {
  //hooks
  const [orderData, setOrderData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState({
    ORDERSTATUSCODE: CON_STATUS_ACTIVE,
    ORDERSTATUSNAME: "Active",
  });
  const [fromDate, setFromDate] = useState(startOfMonth);
  const [toDate, setToDate] = useState(endOfMonthDate);
  const navigate = useNavigate();
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE,USERNAME} = SYS_USER.USER_PARAM || {};

  const orderStatuses = [
    { ORDERSTATUSCODE: CON_STATUS_ACTIVE, ORDERSTATUSNAME: "Active" },
    { ORDERSTATUSCODE: CON_STATUS_PENDING, ORDERSTATUSNAME: "Pending" },
    { ORDERSTATUSCODE: CON_STATUS_RETURN, ORDERSTATUSNAME: "Return" },
  ];
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const theme = useTheme();
  const styles = useStyles(theme);
  const [placedorderItems, setPlacedorderItems] = useState([]);
   const [error, setError] = useState(null);

  useEffect(() => {
    if (selectedStatus?.ORDERSTATUSCODE) {
      fetchOrderData(selectedStatus.ORDERSTATUSCODE);
    }
  }, [selectedStatus, fromDate, toDate]);
  const handleDateChange = (newValue) => {
    if (newValue) {
      // Format the date to YYYY-MM-DD before sending to API
      const formattedDate = newValue.format("MM/DD/YYYY");
      setFromDate(dayjs(formattedDate));
    } else {
      setFromDate(""); // Handle null case
    }
  };

  const handleToDateChange = (newValue) => {
    if (newValue) {
      // Format the date to YYYY-MM-DD before sending to API
      const formattedDate = newValue.format("MM/DD/YYYY");
      setToDate(dayjs(formattedDate));
    } else {
      setToDate(""); // Handle null case
    }
  };

  useEffect(() => {
    // Fetch initial order data when the component mounts    
    fetchPlacedOrders();
  }, []);

  const fetchOrderData = async (statusCode) => {
    setLoading(true);
    const params = {
      COMPCODE,
      LOCCODE,
      RESTCODE,
      FROMDATE: dayjs(fromDate).format("MM-DD-YYYY"),
      TODATE: dayjs(toDate).format("MM-DD-YYYY"),
      STS:
        statusCode === CON_STATUS_ACTIVE
          ? CON_STATUS_ACTIVE
          : statusCode === CON_STATUS_PENDING
          ? CON_STATUS_PENDING
          : statusCode === CON_STATUS_DELETED
          ? CON_STATUS_DELETED
          : CON_STATUS_RETURN,
    };
    try {
      const response = await externalgetApi(ORDER_API_03, "GET", params);
      setOrderData(response || []);
      console.log("response ol", response);
    } catch (err) {
      console.error("Failed to fetch order data:", err);
    } finally {
      setLoading(false);
    }
  };



const fetchPlacedOrders = async () => {
  try {
    const response = await externalgetApi(Approveorder_API_01, "GET", {
      COMPCODE,
      LOCCODE,
      RESTCODE,
      STS: CON_STATUS_PENDING,
      STSN: CON_STATUS_NO,
      STSR: CON_STATUS_RECEIVED,
      ISCASHIER: CON_IS_CASHIER_YES,
    });

    // ✅ Filter orders with AGENTCODE !== 0 and AGENTSTS === "P"
    const filteredOrders = response
      .filter(item => item.AGENTCODE !== 0 && item.AGENTSTS === "P")
      .map(item => ({
        ...item,
        AGENTFEE: currencyFormat(item.AGENTFEE),
        AGENTEXPENSES: currencyFormat(item.AGENTEXPENSES),
        AMOUNT: currencyFormat(item.AMOUNT),

      }));

    console.log("Filtered placed orders list with formatted currency and AGENTSTS === 'P'", filteredOrders);
    setPlacedorderItems(filteredOrders);
  } catch (error) {
    setError(error);
  } finally {
    setLoading(false);
  }
};



//   const mapResultToRows = (result) => {
//     return result.map((item, index) => ({
//       id: index + 1,
//       INVNO: item.INVNO,
//       ORDERCODE: item.ORDERCODE,
//       ORDERENDATE: item.ORDERENDATE,
//       STS:
//         item.STS === CON_STATUS_ACTIVE ? (
//           <Chip
//             label="Order Placed"
//             variant="filled"
//             sx={{
//               boxShadow: 2,
//             }}
//             color="success"
//           />
//         ) : item.STS === CON_STATUS_PENDING ? (
//           <Chip label="Pending" variant="filled" color="error" />
//         ) : item.STS === CON_STATUS_DELETED ? (
//           <Chip label="Cancelled" variant="filled" color="warning" />
//         ) : item.STS === CON_STATUS_RETURN ? (
//           <Chip label="Returned" variant="filled" color="primary" />
//         ) : null,

//       AMOUNT: currencyFormatLKR(item.AMOUNT, "LKR", false),
//     }));
//   };
  //handlers
  const handleStatusChange = (status) => {
    setSelectedStatus(status);
  };

  // const handleStatusChange = (newValue) => {
  //   if (newValue) {
  //     setSelectedStatus(newValue);
  //   } else {

  //     setSelectedStatus(null);
  //     setOrderData([]);
  //   }
  // };

//   const handleItemClick = (ORDERCODE, actionText) => {
//     const selectedItem = orderData.find((item) => item.ORDERCODE === ORDERCODE);
//     if (selectedItem) {
//       navigate(`/ordercancel`, {
//         state: { selectedItem, actionText, ORDERCODE },
//       });
//     }
//   };

const handleItemClick = async (ORDERCODE, actionText) => {
  const selectedItem = placedorderItems.find((item) => item.ORDERCODE === ORDERCODE);
console.log("Selected item:", selectedItem);
  if (!selectedItem) return;

  if (actionText === "Approve") {
    const payload = {
      ordercode:String(ORDERCODE), // Ensure ORDERCODE is a stringORDERCODE,
      remark: "Approved", // You can dynamically set this
      approvedate:new Date().toISOString(),
      
      // approvedate: new Date().toISOString(),
      sts: CON_STATUS_ACTIVE, // Your constant for status
      enuser: USERNAME, // Logged-in user or static value
    };

    try {
      const response = await externalpostApi(Approveorder_API_01, payload);
      console.log("POST success:", response);

      setOpenSnackbar(true); // Show success message or feedback
      fetchPlacedOrders();
    } catch (error) {
      console.error("POST failed:", error);
    }
  } else {
    // Optional: handle other actions like "Reject", "Cancel", etc.
    console.log("Action ignored:", actionText);
  }
};



 const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const menuItems = [
    {
      text: "Approve",
      icon: <FactCheckIcon />,
      onClick: (ORDERCODE) => handleItemClick(ORDERCODE, "Approve"),
    },
    // {
    //   text: "Return/Refund",
    //   icon: <CurrencyExchangeRoundedIcon />,
    //   onClick: (ORDERCODE) => handleItemClick1(ORDERCODE, "Return"),
    // },
  ];

  return (
    <>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                separator={<NavigateNextIcon fontSize="small" />}
                sx={styles.AI_breadcrumbs2}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Cashier</Link>
                <Link underline="none"> Pending Approvals</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item p={2}>
              <Stack
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                padding={1}
                ml={1}
                sx={styles.AI_fixedStack1}
              ></Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      <Box sx={styles.OL_AddStyledBox}>
        {/* <Grid container spacing={1}> */}
        {/* First Row: Back Button */}

        {/* Second Row: Select Location, From Date, To Date, Report Button */}
        <Grid
          container
          spacing={2}
          mr={15}
          sx={styles.OL_AddStyledBox_container}
        >
          {/* <Grid item xs={12} md={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="From Date"
                value={fromDate}
                onChange={handleDateChange}
                inputFormat="MM/DD/YYYY"
                slotProps={{
                  textField: {
                    sx: {
                      width: "100%",
                      "& .MuiInputBase-root": {
                        height: "40px",
                      },
                      "& .MuiInputAdornment-root .MuiIconButton-root": {
                        color: theme.palette.primary.main, // Change icon color here
                      },
                    },
                  },
                  popper: {
                    sx: {
                      "& .MuiPaper-root": {
                        backgroundColor: theme.palette.background.paper, // Background color of the popper
                        boxShadow: "none", // Remove box shadow if needed
                      },
                    },
                  },
                }}
              />
            </LocalizationProvider>
          </Grid> */}
          {/* <Grid item xs={12} md={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="To Date"
                value={toDate}
                onChange={handleToDateChange}
                inputFormat="MM/DD/YYYY"
                slotProps={{
                  textField: {
                    sx: {
                      width: "100%",
                      "& .MuiInputBase-root": {
                        height: "40px",
                      },
                      "& .MuiInputAdornment-root .MuiIconButton-root": {
                        color: theme.palette.primary.main, // Change icon color here
                      },
                    },
                  },
                  popper: {
                    sx: {
                      "& .MuiPaper-root": {
                        backgroundColor: theme.palette.background.paper, // Background color of the popper
                        boxShadow: "none", // Remove box shadow if needed
                      },
                    },
                  },
                }}
              />
            </LocalizationProvider>
          </Grid> */}
          <Grid item xs={0} md={4}></Grid>
          {/* <Grid item xs={12} md={4}>
            <Autocomplete
              value={selectedStatus}
              onChange={(event, newValue) => handleStatusChange(newValue)}
              options={orderStatuses}
              getOptionLabel={(option) => option.ORDERSTATUSNAME || ""}
              isOptionEqualToValue={(option, value) =>
                option.ORDERSTATUSCODE === value?.ORDERSTATUSCODE
              }
              disableClearable
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Order Status"
                  variant="outlined"
                  size="small"
                  // fullWidth
                  sx={{
                    "& .MuiInputBase-root": {
                      // height: "43px",
                      minWidth: "200px",
                      // maxWidth: 600,
                    },
                  }}
                />
              )}
              ListboxProps={{
                style: {
                  maxHeight: 180,
                  backgroundColor: theme.palette.background.paper,
                },
              }}
            />
          </Grid> */}
        </Grid>
        {/* </Grid> */}
      </Box>
      <Box sx={styles.OL_vdg}>
        {loading ? (
          <CircularProgress />
        ) : (
          <ViewData
            columns={Pendindapprovalslistdata.columns}
            rows={placedorderItems}
            menuItems={menuItems}
            tabletitle={Pendindapprovalslistdata.name}
            gridid="ORDERCODE"
          />
        )}
      </Box>
        <Snackbar
                open={openSnackbar}
                autoHideDuration={4000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                sx={{ top: "10%", right: "10%" }}
              >
                <Alert
                  onClose={handleSnackbarClose}
                  severity="success"
                  sx={{ width: "100%" }}
                >
                 Approved Successfully !
                </Alert>
              </Snackbar>
    </>
  );
}

export default Pendingapprovals;
